import React from 'react'
import FallbackImageUpload from './fallback'

let ImagePickerComponent = null

try {
  // Using require instead of import for better build-time handling
  const imagePickerModule = require('@protonapp/runner-imagepicker') // eslint-disable-line global-require
  ImagePickerComponent = imagePickerModule.default || imagePickerModule
} catch (err) {
  console.warn('ImagePicker package not found:', err)
  // Fallback component when package is missing
  ImagePickerComponent = FallbackImageUpload
}

export default function ImageUpload(props) {
  return <ImagePickerComponent {...props} />
}
